import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';

import { routes } from './app.routes';
import { authInterceptor } from './core/http/auth.interceptor';
import { adminAuthRefreshInterceptor } from './core/http/admin-auth-refresh.interceptor';
import { apiBaseUrlInterceptor } from './core/http/api-base-url.interceptor';
import WaselAdminPreset from './core/theme/wasel-admin-preset';
import { provideThemeInit } from './core/theme/theme-mode.service';
import { LocalizationModule } from './core/i18n/localization.module';
import { Translation } from './core/i18n/translation.service';
import { LazyChunkRecoveryErrorHandler } from './core/errors/lazy-chunk-recovery.handler';
import { OperatorPermissions } from './core/auth/operator-permissions.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(LocalizationModule.forRoot()),
    // Bring back the operator's language (and its dictionaries) before anything renders.
    provideAppInitializer(() => inject(Translation).restoreStoredLanguage()),
    // Resolve light/dark (stored, else OS preference, else light) before the first route renders.
    provideThemeInit(),
    // Load the operator's permission keys for the stored session, and again whenever the access token changes.
    provideAppInitializer(() => inject(OperatorPermissions).watchSession()),
    provideHttpClient(withInterceptors([apiBaseUrlInterceptor, adminAuthRefreshInterceptor, authInterceptor]))
    ,
    MessageService,
    ConfirmationService,
    {
      provide: ErrorHandler,
      useClass: LazyChunkRecoveryErrorHandler
    },
    providePrimeNG({
      overlayOptions: {
        appendTo: 'body'
      },
      theme: {
        preset: WaselAdminPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'base, primeng, components, utilities'
          },
          defaultIconSet: 'primeicons',
          darkModeSelector: '.wasel-dark'
        }
      }
    })
  ]
};
